import { Button, CircularProgress, ClickAwayListener } from "@material-ui/core";
import { format } from "date-fns";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FacematchAxiosClient } from "../../../Network/FacematchAxiosClient";
import { selectUser } from "../../../store/selectors/auth";
import { useNotification } from "../../Notifications/NotificationProvider";
import Loader from "../../Shared/Loader";
import "../styles/reviewFaceMatching.scss";
import rejected from "../svgs/Close cr-fr 1.svg";
import user from "../svgs/account_circle.svg";
import pending from "../svgs/calendar_month.svg";
import done from "../svgs/done_all.svg";
import magic from "../svgs/magic_button.svg";
import scheudle from "../svgs/schedule.svg";
import NotFound from "../temp/image-not-found.png";
import ReviewModal from "./reviewModal";
import StatusChip from "./statusChip";

function getRandomArbitrary() {
  return Math.round(Math.random() * (95 - 10) + 10);
}

class CircularProgressWithLabel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [70],
      options: {
        chart: {
          height: 10,
          width: 10,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "80%",
            },
            dataLabels: {
              showOn: "always",
              name: {
                offsetY: -10,
                show: false,
                color: "#888",
                fontSize: "13px",
              },
              value: {
                color: "#111",
                fontSize: "10px",
                show: true,
              },
            },
          },
        },

        labels: ["Cricket"],
      },
    };
  }
  render() {
    const randomNumber = getRandomArbitrary();
    return (
      <div
        className="face-match-bar"
        style={{
          background: `radial-gradient(closest-side, white 50%, transparent 80%, transparent 100%), conic-gradient(#e2136e ${randomNumber}%, #e2136e33 0deg)`,
        }}
      >
        <div className="inner-circle"></div>
        <p className="percentage">{randomNumber}%</p>
      </div>
    );
  }
}

const statusConfig = {
  REQ_APPROVED: {
    title: "Approved",
    className: "approve",
    icon: done,
    noun: "Aprroval",
  },
  REQ_DENIED: {
    title: "Rejected",
    className: "reject",
    icon: rejected,
    noun: "Rejection",
  },
  REQ_SUBMITTED: {
    title: "Pending",
    className: "pending",
    icon: pending,
    noun: "Requested",
  },
};

const FetchingOverlay = () => {
  return (
    <div className="fetching-overlay">
      <Loader />
    </div>
  );
};

export default function TransferList({
  transferList,
  loadTransferList,
  filter,
  isFetching,
}) {
  return (
    <div className="transfer-list-container">
      {isFetching && <FetchingOverlay />}
      {transferList.length > 0 ? (
        transferList.map((item) => (
          <TransferListItem
            key={item.id}
            item={item}
            loadTransferList={loadTransferList}
          />
        ))
      ) : (
        <div className="blank-list-text">
          No {statusConfig[filter] && statusConfig[filter].title.toLowerCase()}{" "}
          item
        </div>
      )}
    </div>
  );
}

function TransferListItem({ item, loadTransferList }) {
  const [isOpenReviewModal, setIsOpenReviewModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [action, setAction] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const dispatchNotification = useNotification();
  const currentUser = useSelector(selectUser);

  const handleClickRejectPop = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseRejectPop = () => {
    setAnchorEl(null);
  };
  const postDecision = (action) => {
    setLoading(true);
    setAction(action);

    const obj = {
      id: item.id,
      managerName: currentUser.username,
      managerPhone: currentUser.contact_number,
    };
    FacematchAxiosClient.post(`/selfie/${action}`, obj)
      .then((res) => {
        //setStatus("success");
        setAction(null);
        setLoading(false);
        loadTransferList();
      })
      .catch((err) => {
        setAction(null);
        setLoading(false);
        console.log(err.response);
        //setStatus("failed");
        // console.log("fail");
      });
  };

  // console.log(item);

  return (
    <ClickAwayListener onClickAway={() => setShowOverlay(false)}>
      <div
        key={item.current_route_id + item.field_force_id}
        className="transfer-item"
        style={{
          height: 520,
          width: "15%",
          minWidth: 300,
          margin: 15,
          position: "relative",
        }}
      >
        <ReviewModal
          open={isOpenReviewModal}
          setOpen={setIsOpenReviewModal}
          details={item}
          loadTransferList={loadTransferList}
        />

        <div
          className={
            showOverlay ? "list-item-overlay visible" : "list-item-overlay"
          }
        ></div>

        <div className="info-images">
          <div
            className="image-with-text"
            style={{ width: "100%", marginRight: 5 }}
            onClick={() => setIsOpenReviewModal(true)}
          >
            <img
              src={item.imageUrl}
              className="image-container small-img"
              alt=""
            />
            {item.status === true ? (
              <div className="title approve small">Approved</div>
            ) : item.status === false ? (
              <div className="title reject small">Rejected</div>
            ) : (
              <div className="title small">Attendence selfie</div>
            )}
          </div>
          <div
            className="image-with-text"
            style={{ width: "100%" }}
            onClick={() => setIsOpenReviewModal(true)}
          >
            <img
              src={`${item.user ? item.user.imageUrl : NotFound}`}
              className="image-container small-img"
              alt=""
            />
            <div className="title small">Original</div>
          </div>
        </div>

        <StatusChip status={item.status} />

        <div className="info">
          <img src={magic} alt="face-match-score" />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={{ marginLeft: 0 }}>
              <p>Face matching score</p>
              {isNaN(item.matchScore)
                ? "n/a"
                : `Face matched ${item.matchScore}%`}
            </div>
            {/* <CircularProgressWithLabel /> */}
          </div>
        </div>

        <div className="info">
          <img src={scheudle} alt="time" />
          <div>
            <p>Attendance date and time</p>
            {format(new Date(item.selfieTime), "dd MMM yyyy, h:mm a")}
          </div>
        </div>

        <div className="info">
          <img src={user} alt="user" />
          <div>
            <p>Field force</p>
            {item.user ? item.user.name : "n/a"}
          </div>
        </div>

        {/* <div className="info">
        <img src={location} alt="bkash" />
        <div>
          <p>Address</p>
          {item.outlet__address}
        </div>
      </div> */}

        {
          <div className="button-container">
            <Button
              className="button details"
              onClick={() => setIsOpenReviewModal(true)}
            >
              {"Show more details "}
            </Button>
            {item.status === null && (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Button
                  className="button reject"
                  onClick={() => postDecision("reject")}
                  //onClick={() => setShowOverlay(true)}
                  disabled={loading}
                  //onClick={handleClickRejectPop}
                >
                  {loading && action === "reject" && (
                    <CircularProgress
                      style={{ marginRight: 5, color: "rgba(238, 50, 53, 1)" }}
                      size={12}
                    />
                  )}
                  {action === "reject" ? "Rejecting" : "Reject"}
                </Button>
                <Button
                  className="button review"
                  onClick={() => postDecision("approve")}
                  //onClick={() => setShowOverlay(true)}
                  disabled={loading}
                >
                  {loading && action === "approve" && (
                    <CircularProgress
                      style={{ marginRight: 5, color: "rgb(0, 177, 54)" }}
                      size={12}
                    />
                  )}
                  {action === "approve" ? "Approving" : "Approve"}
                </Button>
              </div>
            )}
          </div>
        }
      </div>
    </ClickAwayListener>
  );
}
